import React, {Fragment} from "react";
import {Grid, TextField, Typography, MenuItem, Button, useTheme} from "@material-ui/core";
import Widget from "../../components/Widget";
import ProgressOr from "../../components/ProgressOr";
import Rest from "../../helpers/Rest";
import {Customers} from "../../context/CustomersContext";

const ID = 0, SITE_ID = 1, NAME = 2, MAX_OCCUPANCY = 3
const LOCAL_STORAGE_KEY = 'ACTIVE_ZONE'

class Occupancy extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            name: ""
        }
        this.zoneMap = {}
        this.siteMap = {}
        this.tokens = {}
        this.fetchDeps()
    }

    getDefaultZone(zones, customerId){
        return zones.find(z => this.siteMap[z[SITE_ID]] === customerId)
    }

    changeCustomer(e){
        const customer = e.target.value
        const zone = this.getDefaultZone(this.state.zones, customer)
        this.setState({
            customer: customer,
            zone: zone ? zone[ID] : 0,
            max: zone ? zone[MAX_OCCUPANCY] : 0,
            name: zone ? zone[NAME] : ""
        })
    }

    customers(){
        return (
            <TextField
                label="Select Customer"
                variant="outlined"
                value={this.state.customer}
                onChange={this.changeCustomer.bind(this)}
                fullWidth select
            >
                {this.customersWithZones.map(customer => (
                    <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>
                ))}
            </TextField>
        )
    }

    setCustomersWithZones(zones, customers){
        this.customersWithZones = Object.values(zones.reduce((accum, zone) => {
            const id = this.siteMap[zone[SITE_ID]]
            accum[id] = customers.map[id]
            return accum
        }, {})).sort((a, b) => a.name.localeCompare(b.name))
    }

    setDefaultState(zones, customers, customerId, zone){
        this.setState({
            zones: zones,
            customers: customers,
            customer: customerId,
            zone: zone[ID],
            max: zone[MAX_OCCUPANCY],
            name: zone[NAME]
        })
    }

    async fetchDeps(){
        const zones = await Rest.get("occupancy/zone/list").then(list => {
            list.forEach(item => this.zoneMap[item[ID]] = item)
            return list.sort((a, b) => a[NAME].localeCompare(b[NAME]))
        })
        const customers = await this.props.customers.fetchCustomers()
        customers.list.forEach(customer => {
            customer.sites.forEach(site => this.siteMap[site.id] = customer.id)
        })
        this.setCustomersWithZones(zones, customers)
        if (!this.customersWithZones){
            this.props.history.push("edit-device")
            return
        }
        const def = window.localStorage.getItem(LOCAL_STORAGE_KEY)
        if (def){
            const {zone, token} = JSON.parse(def)
            this.tokens[zone[ID]] = token
            this.setDefaultState(zones, customers, this.siteMap[zone[SITE_ID]], zone)
        }
        else {
            const customer = this.customersWithZones[0]
            this.setDefaultState(zones, customers, customer.id, this.getDefaultZone(zones, customer.id))
        }
    }

    ready(){
        return this.state.zones && this.state.customers
    }

    filterZones(){
        const id = this.state.customer, {list, map} = this.state.customers
        const customer = id ? map[id] : list[0]
        if (!customer){
            return []
        }
        const set = customer.sites.reduce((accum, site) => {
            accum[site.id] = true
            return accum
        }, {})
        return this.state.zones.filter(zone => zone[SITE_ID] in set)
    }

    setZone(e){
        const value = e.target.value
        const zone = this.zoneMap[value]
        this.setState({
            zone: value,
            max: zone[MAX_OCCUPANCY] || 0,
            name: zone[NAME]
        })
    }

    setName(e){
        this.setState({
            name: e.target.value
        })
    }

    zones(){
        return (
            <TextField
                label="Select Zone"
                variant="outlined"
                value={this.state.zone}
                onChange={this.setZone.bind(this)}
                fullWidth select
            >
                {this.filterZones().map(zone => {
                    const id = zone[ID]
                    return (
                        <MenuItem key={id} value={id}>{zone[NAME]}</MenuItem>
                    )
                })}
            </TextField>
        )
    }

    maxOccupancy(){
        return <TextField
            type="number"
            label="Maximum Occupants"
            variant="outlined"
            value={this.state.max}
            onChange={e => this.setState({max: parseInt(e.target.value)})}
            fullWidth
        />
    }

    saveZone(){
        this.setState({saving: true})
        const {zone, max, name} = this.state
        const row = this.zoneMap[zone]
        row[MAX_OCCUPANCY] = max
        Rest.put("occupancy/zone/" + this.state.zone, {
            id: zone,
            site_id: row[SITE_ID],
            name: name,
            max_occupancy: max
        }).then(reply => {
            this.tokens[zone] = reply
            row[NAME] = name
            row[MAX_OCCUPANCY] = max
            this.setState({saving: false})
        })
    }

    openDisplay(token){
        const state = {
            token: token,
            zone: this.zoneMap[this.state.zone]
        }
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state))
        this.props.history.push({
            pathname: "/occupancy",
            state: state
        })
    }

    open(){
        const {zone} = this.state
        const token = this.tokens[zone]
        if (token) {
            this.openDisplay(token)
        }
        else{
            this.setState({
                saving: true
            })
            Rest.get(`occupancy/zone/${zone}/token`).then(this.openDisplay.bind(this))
        }
    }

    buttons(){
        const {zone, max, saving, name} = this.state
        const obj = this.zoneMap[zone]
        const currentMax = obj[MAX_OCCUPANCY], currentName = obj[NAME]
        const disabled = max === currentMax && name === currentName, style = {
            marginRight: this.props.theme.spacing(2)
        }
        return (
            <ProgressOr showProgress={saving} progressMessage="Saving...">
                <Button
                    disabled={disabled}
                    variant="contained"
                    style={style}
                    onClick={() => this.setState({
                        max: currentMax,
                        name: currentName
                    })}
                >Cancel</Button>
                <Button
                    disabled={disabled}
                    variant="contained"
                    color="primary"
                    style={style}
                    onClick={this.saveZone.bind(this)}
                >Save</Button>
                <Button
                    variant="contained"
                    color="secondary"
                    style={{color:"#fff"}}
                    onClick={this.open.bind(this)}
                >Open</Button>
            </ProgressOr>
        )
    }

    selectors(){
        if (!this.ready()){
            return null
        }
        return (
            <Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Name"
                            value={this.state.name}
                            onChange={this.setName.bind(this)}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {this.customers()}
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        {this.zones()}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        {this.maxOccupancy()}
                    </Grid>
                    <Grid item container justify="flex-end">
                        {this.buttons()}
                    </Grid>
                </Grid>
            </Fragment>
        )
    }

    render(){
        return <Fragment>
            <Grid container spacing={2} style={{maxWidth:640}}>
                <Grid item xs={12}>
                    <Typography variant="h1">
                        Occupancy
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Widget title="Setup Occupancy Screen" disableWidgetMenu>
                        <ProgressOr showProgress={!this.ready()} progressMessage="Loading customers...">
                            {this.selectors()}
                        </ProgressOr>
                    </Widget>
                </Grid>
            </Grid>
        </Fragment>
    }
}

export default function(props){
    const theme = useTheme()
    return (<Customers.Consumer>
        {customers => (
            <Occupancy customers={customers} theme={theme} {...props}/>
        )}
    </Customers.Consumer>)
}
